t = require('app/scripts/views/internal/teacup-with-helpers')('popover_limit_exceeded')


module.exports = t.renderable (limitType)->
  t.div '.error.js-limit-exceeded', { style: "margin: 12px 0 6px;" }, ->
    if limitType == 'perCard'
      t.format 'attachments-per-card-exceeded'
    else if limitType == 'perBoard'
      t.format 'attachments-per-board-exceeded'
